import { NavItem } from 'types'

export const NAV_ITEMS_CONST: NavItem[] = [
  { label: '¿CÓMO FUNCIONA?', targetId: '#howWorks' },
  { label: 'FUNCIONALIDADES', targetId: '#functionalities' },
  { label: 'NUNA EXPRESS', targetId: '#howWorks' },
  { label: 'PLANES', targetId: '#plans' },
  {
    label: 'CONTÁCTANOS',
    targetIdDesktop: '#footerLanding',
    targetIdMobile: '#footerLanding',
  },
]
